/**
 * Practice-mode flag (free 1v1 vs the in-browser bot) — module-scope so the
 * stores can read it at import time, before main.ts boots.
 *
 * Direct play.hupper.fun visits used to dead-end in an offline walk-around
 * (anon fps_arena joins are AUTH_REQUIRED-rejected in production). Now they
 * get a real match against PracticeBot in the anon `fps_practice` room.
 * Strictly scoped to that visitor path so nothing else changes:
 *   - any identity/relaunch param (token/wallet/reconnect/custom/tournament)
 *     → the embedded paid flow, untouched;
 *   - any `?…demo`/preview param → those debug loops keep their offline
 *     stage (a bot would walk through the cinematics under test);
 *   - localhost keeps the standalone two-tab / scripts/bot.mjs dev flow
 *     unless `?practice=1` opts in; `?practice=0` force-disables anywhere.
 *
 * Also the switch for practice-scoped persistence: settingsStore and
 * crosshairStore suffix their localStorage keys with `.practice` when this
 * is set, so a visitor tuning mouse/volume/crosshair in a practice match
 * never touches the settings of the real (embedded) game and vice versa.
 */
const launch = new URLSearchParams(window.location.search);

const practiceParam = launch.get("practice");
const isLocalDevHost =
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const previewParam = !!(
  launch.get("vsintro") ||
  launch.get("halftime") ||
  launch.get("matchend") ||
  launch.get("killdemo") ||
  launch.get("reportdemo") ||
  launch.get("chat")
);

export const isPracticeMode: boolean =
  practiceParam !== "0" &&
  !launch.get("token") &&
  !launch.get("wallet") &&
  !launch.get("reconnect") &&
  !launch.get("customMatchId") &&
  !launch.get("tournamentMatchId") &&
  !previewParam &&
  (practiceParam === "1" || !isLocalDevHost);
